export default __webpack_public_path__ + "a28268c53bd7071056893d0028977600.svg";